import { render, staticRenderFns } from "./expandList.vue?vue&type=template&id=1b594b01"
import script from "./expandList.vue?vue&type=script&lang=js"
export * from "./expandList.vue?vue&type=script&lang=js"
import style0 from "./expandList.vue?vue&type=style&index=0&id=1b594b01&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1b594b01')) {
      api.createRecord('1b594b01', component.options)
    } else {
      api.reload('1b594b01', component.options)
    }
    module.hot.accept("./expandList.vue?vue&type=template&id=1b594b01", function () {
      api.rerender('1b594b01', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/activity/couponExpand/expandList.vue"
export default component.exports